/** @format */

import styled from 'styled-components';

export const ModalBackground = styled.div`
	background: rgba(59, 59, 58, 0.8);
	width: 100vh;
	height: 100vh;
	z-index: 40;
	position: fixed;
	display: flex;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
`;

export const RightSidebarWrapper = styled.div`
	background: #ffffff;
	position: fixed;
	right: 0;
	width: 292px;
	height: calc(100% - 64px);
`;

export const RightSidebarProfileWrapper = styled.div`
	background: #ffd934;
	border-radius: 20px;
`;

export const NavbarWrapper = styled.div`
	height: 64px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	padding: 0 10px 0 10px;
`;

export const ContentContainer = styled.div`
	overflow: auto;
	background: #f5f5f3;
	height: 100%;
	border-top: 1px solid rgba(59, 59, 58, 0.1);
`;

export const FirstWrapper = styled.div`
	& > div {
		& > span {
			margin-left: 15px;
		}
	}
`;

export const SecondWrapper = styled.div`
	& > div {
		& > a {
			margin-left: 30px;
		}
	}
`;

export const UserWrapper = styled.div`
	margin-top: 12px;
	background: #FFD934;
	border-radius: 50px;
	width: 142px;
	height: 38px;
	display: flex;
	align-items: center;
`
export const CheckProfileWrapper = styled.div`
	margin-left: 20px;
	margin-right: 8px;
`

export const UserAvatarContainer = styled.div`
	overflow: hidden;
	vertical-align: middle;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background: white;
	cursor: pointer;
`

export const ProfileModalWrapper = styled.div` 
	top: 60px;
	right: 10px;
	position: fixed;
`
